import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import condiciones from '../components/condiciones';
import { Client } from '../client';
import NotFoundPage from '../components/NotFoundPage';
import ContentData from '../data/contentData.json';
import JsonData from '../data/dataPages.json';
import politicasData from '../data/politicasSeguridadInformacion.json';
import { PageServices } from '../components/PageServices';
import { Footertwo } from '../components/Footertwo';
import { PageQuienesSomos } from '../components/PageQuienesSomos';
import { PageProveedores } from '../components/PageProveedores';
import { PageSedes } from '../components/PageSedes';
import { PageNews } from '../components/PageNews';
import { PageTemplatePostNews } from '../components/PageTemplatePostNews';
import data from '../data/data.json';
import Peticiones from '../views/Peticiones';
import Navbar from '../components/Navegacion/Navbar';
import { PageContactFamedic } from '../components/PageContactFamedic';
import { PageDoctorFamedic } from '../components/PageDoctorFamedic';
import { PageFuncionarios } from '../components/PageFuncionarios';
import { PagePreguntasFrecuentes } from '../components/PagePreguntasFrecuentes';
import Flotante from '../components/Flotante/Flotante';
import { PageCuota } from '../components/PageCuota';
import { PageAsociacionUsuarios } from '../components/PageAsociacionUsuarios';
import { PageHumanizacion } from '../components/PageHumanizacion';
import { PageNormatividad } from '../components/PageNormatividad';
import { PageMiembros } from '../components/PageMiembros';
import { PageFunciones } from '../components/PageFunciones';
import { PageTrabajeConNosotros } from '../components/PageTrabajeConNosotros';
import { PageLaboratorio } from '../components/PageLaboratorio';
import { PageOrdenes } from '../components/PageOrdenes';
import { PageDoctorFamedicIframe } from '../components/PageDoctorFamedicIframe';
import ModeloAtencion from '../views/ModeloAtencion';
import ServicioDetalle from '../views/ServicioDetalle';
import { PagePoliticaSST } from '../components/PagePoliticaSST';
import { PagePoliticaInstitucional } from '../components/PagePoliticaInstitucional';
import { PagePoliticaCalidad } from '../components/PagePoliticaCalidad';
import { PageAvisoPrivacidad } from '../components/PageAvisoPrivacidad';
import { PagePoliticaDatosPersonales } from '../components/PagePoliticaDatosPersonales';
import { PageTerminosCondiciones } from '../components/PageTerminosCondiciones';
import { PagePQRiframe } from '../components/PagePQRiframe';
import { PageLineaAtencionNacional } from '../components/PageLineaNacional';

export default class Routes extends Component {
  state = {
    landingPageData: {},
    contentPage: {},
    politicasData: {},
  };
  //funcion que carga el json con la informcion de las paginas a mostrar en un estado

  getlandingPageData() {
    this.setState({
      landingPageData: JsonData,
      contentPage: ContentData,
      politicasData: politicasData,
    });
  }

  //funcion que se carga al momento de cargar la pagina y llama a la funcion getlandingPageData

  componentDidMount() {
    this.getlandingPageData();
  }

  render() {
    //componente encargado del manejo de las rutas en la app
    return (
      <BrowserRouter>
        <Navbar />
        <Flotante />
        <Switch>
          <Route path='/conditions' exact component={condiciones} />
          <Route path='/' exact component={Client} />
          {/* <Route exact path='/pqr' component={Peticiones} /> */}
          <Route exact path='/pqr' component={PagePQRiframe} />
          <Route path='/services' exact>
            <PageServices />
          </Route>
          <Route path='/quienes' exact>
            <PageQuienesSomos />
          </Route>
          <Route path='/proveedores' exact>
            <PageProveedores />
          </Route>
          <Route path='/sedes' exact>
            <PageSedes />
          </Route>
          <Route path='/noticias' exact>
            <PageNews />
          </Route>
          <Route path='/unanoticia' exact>
            <PageTemplatePostNews
              dataNews={data.UnaNoticia}
              dataAllNews={data.Noticias}
            />
          </Route>
          <Route path='/contacto' exact>
            <PageContactFamedic />
          </Route>
          <Route path='/servicio-detalle' exact>
            <ServicioDetalle />
          </Route>
          <Route path='/doctorfamedic' exact>
            {/* <PageDoctorFamedic /> */}
            <PageDoctorFamedicIframe />
          </Route>
          <Route path='/funcionarios' exact>
            <PageFuncionarios />
          </Route>
          <Route path='/preguntasfrecuentes' exact>
            <PagePreguntasFrecuentes />
          </Route>

          <Route path='/cuota' exact>
            <PageCuota />
          </Route>

          <Route path='/modelo-atencion' exact>
            <ModeloAtencion />
          </Route>

          <Route path='/asociacionUsuarios' exact>
            <PageAsociacionUsuarios />
          </Route>

          <Route path='/humanizacion' exact>
            <PageHumanizacion />
          </Route>

          <Route path='/normatividad' exact>
            <PageNormatividad />
          </Route>

          <Route path='/miembros' exact>
            <PageMiembros />
          </Route>

          <Route path='/funciones' exact>
            <PageFunciones />
          </Route>

          <Route path='/trabajeconnosotros' exact>
            <PageTrabajeConNosotros />
          </Route>

          <Route path='/laboratorio' exact>
            <PageLaboratorio />
          </Route>

          <Route path='/laboratorios' exact>
            <PageLaboratorio />
          </Route>

          <Route path='/ordenes' exact>
            <PageOrdenes />
          </Route>

          <Route path='/telemedicina' exact>
            <PageDoctorFamedicIframe />
          </Route>

          <Route path='/politicasst' exact>
            <PagePoliticaSST />
          </Route>

          <Route path='/politicainstitucional' exact>
            <PagePoliticaInstitucional />
          </Route>

          <Route path='/politicacalidad' exact>
            <PagePoliticaCalidad />
          </Route>

          <Route path='/politicadatospersonales' exact>
            <PagePoliticaDatosPersonales />
          </Route>

          <Route path='/avisoprivacidad' exact>
            <PageAvisoPrivacidad />
          </Route>

          <Route path='/terminosycondiciones' exact>
            <PageTerminosCondiciones />
          </Route>

          <Route path='/lineaatencionnacional' exact>
            <PageLineaAtencionNacional />
          </Route>

          <Route path='*' component={NotFoundPage}></Route>
        </Switch>
        <Footertwo data={this.state.landingPageData.Footer} />
      </BrowserRouter>
    );
  }
}
